import { apiGateway } from '../api';

async function buscaFaturas(body) {
    try {
        const response = await apiGateway.post('/faturas/dados', body);
        return response.data;
    } catch (error) {
        return error;
    }
}

async function linkNfe(body) {
    try {
        const response = await apiGateway.post('/faturas/link-nfe', body);
        return response.data;
    } catch (error) {
        return error;
    }
}

async function boletoDaFatura(body) {
    try {
        const response = await apiGateway.post('/faturas/boletos', body);
        return response.data;
    } catch (error) {
        return error;
    }
}

async function relatoriosDoKit(numFatura, nomeArquivo) {
    try {
        const response = await apiGateway.get(`/faturas/${numFatura}/kit/zip?nomeArquivo=${nomeArquivo}`);
        return response.data;
    } catch (error) {
        return error;
    }
}

async function demonstrativoFaturamento(numFatura) {
    try {
        const response = await apiGateway.get(`/faturas/${numFatura}/demonstrativo-faturamento`);
        return response.data;
    } catch (error) {
        return error;
    }
}

async function solicitarEKit(numFatura) {
    try {
        const { data: solicitacao } = await apiGateway.post(`/ekit-faturamento/faturas/${numFatura}`);

        if (solicitacao.numeroSolicitacaoArquivo) return solicitacao.numeroSolicitacaoArquivo;

        return false;
    } catch (error) {
        return false;
    }
}

async function downloadEKit(numFatura, numeroSolicitacaoArquivo) {
    try {
        const { data: responseFile } = await apiGateway.get(
            `/ekit-faturamento/faturas/${numFatura}/arquivos/${numeroSolicitacaoArquivo}`
        );

        return responseFile;
    } catch (error) {
        return error.response.data;
    }
}

export {
    buscaFaturas,
    linkNfe,
    boletoDaFatura,
    relatoriosDoKit,
    demonstrativoFaturamento,
    solicitarEKit,
    downloadEKit,
};
